import React from 'react'
import MyCourses from '../components/MyCourses'
import { Box } from '@chakra-ui/react'
const CoursesScreen = () => {
  return (
    <Box>
      <MyCourses/>
    </Box>
  )
}

export default CoursesScreen
